export default __webpack_public_path__ + "static/media/forklift_white.d20e6650.svg";